import { FilePurpose } from '../../libs/interfaces/filePurpose';
import { request } from '../../utils/request';

type requestProps = {
  file_type: string;
  file_purpose: FilePurpose;
  file_url: string;
  authToken: string;
  requires_image?: boolean;
};

export const sendFileInfoToBackend = ({
  authToken,
  file_url,
  file_purpose,
  file_type,
  requires_image = true,
}: requestProps) =>
  request({
    method: 'POST',
    url: `/files/save-file-url?requires_image=${requires_image}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    formData: {
      file_type,
      file_purpose,
      file_url: file_url,
    },
  });
